import { useTranslation } from '@/hooks/useTranslation';
import { useRef } from 'react';
import NeuralNetwork3D from '@/components/NeuralNetwork3D';

const HeroSection = () => {
  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);

  // Split headline to highlight the accent word
  const headline = t.hero.headline || "We Architect the AI‑Powered Future.";
  const highlightWord = t.hero.highlightWord || "Architect";
  const parts = headline.split(highlightWord);

  return (
    <section id="hero">
      <NeuralNetwork3D />
      
      <div className="hero-overlay" />

      <div className="hero-content" ref={contentRef}>
        <div className="hero-eyebrow hero-anim">
          <span className="hero-eyebrow-dot" />
          <span className="hero-eyebrow-text">{t.hero.eyebrow || "Neural AI · Live System"}</span>
          <span className="hero-eyebrow-line" />
        </div>

        <h1 className="hero-h hero-anim">
          {parts[0]}
          <span className="gline">{highlightWord}</span>
          {parts[1]}
        </h1>

        <p className="hero-sub hero-anim">
          {t.hero.subtitle || t.hero.description}
        </p>

        <div className="hero-btns hero-anim">
          <a href="#services" className="btn-hero-p">{t.hero.cta1}</a>
          <a href="/experience-lab" className="btn-hero-s">{t.hero.cta2}</a>
        </div>
      </div>

      <div className="hero-scroll-cue hero-anim">
        <div className="scroll-line" />
        <span className="scroll-label">{t.hero.scrollLabel || t.hero.scroll || "Scroll to explore"}</span>
      </div>
    </section>
  );
};

export default HeroSection;
